/* @ngInject */

export default (CompareProductSplit) => {
  /*
   * Constructor
   * --------------------------------------------------------------------------------
   */
  function CompareProduct(
    id,
    idLender,
    productSplits,
    repayments,
    costs,
    commissionsPayable,
    shortTotalCosts,
    comparativeSaving,
    bestSaving,
    isPreferred
  ) {
    this.id = id;
    this.idLender = idLender;
    this.productSplits = productSplits;
    this.repayments = repayments;
    this.costs = costs;
    this.commissionsPayable = commissionsPayable;
    this.shortTotalCosts = shortTotalCosts;
    this.comparativeSaving = comparativeSaving;
    this.bestSaving = bestSaving;
    this.isPreferred = isPreferred;

    if (!this.costs?.interestWithOffset) {
      this.costs.interestWithOffset = 0;
    }
    if (!this.costs?.interestOffsetSavings) {
      this.costs.interestOffsetSavings = 0;
    }
    if (!this.costs?.offsetBalance) {
      this.costs.offsetBalance = 0;
    }
    if (!this.costs?.monthlyOffsetContribution) {
      this.costs.monthlyOffsetContribution = 0;
    }
    if (!this.costs?.cashback) {
      this.costs.cashback = 0;
    }
    if (!this.costs?.timeSaved) {
      this.costs.timeSaved = '';
    }
    if (!this.costs?.revisedLoanTerm) {
      this.costs.revisedLoanTerm = '';
    }
    if (!this.commissionsPayable?.upfront) {
      this.commissionsPayable.upfront = 0;
    }
    if (!this.commissionsPayable?.trail) {
      this.commissionsPayable.trail = 0;
    }
  }

  /*
   * Static methods
   * --------------------------------------------------------------------------------
   */
  CompareProduct.Blank = function () {
    return CompareProduct.Build({
      id: _.uuid(),
      idLender: '',
      productSplits: [],
      repayments: {
        initialMonthlyRepayment: 0,
        ongoingMonthlyRepayment: 0,
        ongoingMonthlyRepaymentBuffer: 0,
        upfrontFees: 0,
        monthlyFees: 0,
        annualFees: 0
      },
      costs: {
        principal: 0,
        interest: 0,
        interestWithOffset: 0,
        fees: 0,
        interestOffsetSavings: 0,
        offsetBalance: 0,
        monthlyOffsetContribution: 0,
        cashback: 0,
        total: 0,
        timeSaved: '',
        revisedLoanTerm: ''
      },
      commissionsPayable: {
        upfront: 0,
        trail: 0
      },
      shortTotalCosts: 0,
      comparativeSaving: 0,
      bestSaving: false,
      isPreferred: false
    });
  };
  CompareProduct.Build = function (data) {
    return new CompareProduct(
      data.id ? data.id : _.uuid(),
      data.idLender ? data.idLender : '',
      _.map(_.compact(data.productSplits), (productSplit) =>
        CompareProductSplit.Build(productSplit)
      ),
      data.repayments
        ? data.repayments
        : {
            initialMonthlyRepayment: 0,
            ongoingMonthlyRepayment: 0,
            ongoingMonthlyRepaymentBuffer: 0,
            upfrontFees: 0,
            monthlyFees: 0,
            annualFees: 0
          },
      data.costs
        ? data.costs
        : {
            principal: 0,
            interest: 0,
            interestWithOffset: 0,
            fees: 0,
            interestOffsetSavings: 0,
            offsetBalance: 0,
            monthlyOffsetContribution: 0,
            cashback: 0,
            total: 0,
            timeSaved: '',
            revisedLoanTerm: ''
          },
      data.commissionsPayable
        ? data.commissionsPayable
        : {
            upfront: 0,
            trail: 0
          },
      data.shortTotalCosts ? data.shortTotalCosts : 0,
      data.comparativeSaving ? data.comparativeSaving : 0,
      data.bestSaving ? data.bestSaving : false,
      data.isPreferred ? data.isPreferred : false
    );
  };

  return CompareProduct;
};
